import { Component, forwardRef, Inject, ViewChild } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams, Platform, Searchbar, Events, ToastController } from 'ionic-angular';
import { EbsWebService } from "../../services/ebsWebService";
import { PrintService } from "../../services/printService";
import { EbsComponentService } from "../../services/ebsComponentService";
import { PopoverController } from 'ionic-angular';
import { TablePopoverMore } from '../../popovers/tablepopover-more/tablepopover-more';
import { TablePopoverLayout } from '../../popovers/tablepopover-layout/tablepopover-layout';

declare var $;



@Component({
  selector: 'page-table',
  templateUrl: 'table.html',
  providers: [EbsWebService, PrintService]
})
export class Table {
  selectedItem: any;
  title: any;
  data: any;
  tableData: any;
  getTableDataUrl: string = "";
  searchword: string = "";
  beforeSearchData: any;
  showSpinner: boolean = false;
  table: any = null;
  depth: any;
  addObj: any;
  saveLayoutObj: any;
  layout: any;
  @ViewChild("searchbar") searchbar: Searchbar;

  constructor(public navCtrl: NavController, public platform: Platform,
    public navParams: NavParams,
    private _ebsWebService: EbsWebService, @Inject(forwardRef(() => EbsComponentService)) private _ebsComponentService: EbsComponentService,
    public loadingCtrl: LoadingController, public alertCtrl: AlertController,
    public events: Events,
    private printService: PrintService,
    public popoverCtrl: PopoverController,
    private toastCtrl: ToastController) {
    this.selectedItem = navParams.get('item');
    this.getTableDataUrl = navParams.get('actionURL');


    this.events.subscribe('table:reloadPageWithResponse', (res) => {
      let collapsedStatus = [];
      this.getCollapsedStatus(this.tableData.body, collapsedStatus);
      this.processData(res);
      this.setCollapsedStatus(this.tableData.body, collapsedStatus);
    });
  }

  ionViewDidLoad() {
    setTimeout(() => {
      if (typeof this.searchbar != "undefined" && !this.platform.is("tablet")) {
        this.searchbar.setFocus();
      }

      //ZAM-400
      $("table button").attr("tabindex", "-1");
      $("table input").attr("tabindex", "-1");
      $("table input.number").attr("tabindex", "0");

    }, 1000);
  }

  ionViewWillEnter() {
    this.events.subscribe('table:updateLayout', (newLayout) => {
      console.log(newLayout, 'new layout');
      this.updateLayout(newLayout);
      this.saveLayout(newLayout);
      console.log('updated grouping');
    });

    let collapsedStatus = this.navParams.get('collapsedStatus');
    if (this.tableData != undefined && collapsedStatus == undefined) { // if return from view, check which row should be collapsed
      collapsedStatus = [];
      this.getCollapsedStatus(this.tableData.body, collapsedStatus);
    } else if (this.tableData == undefined && collapsedStatus == undefined) {
      collapsedStatus = [];
    }

    if (typeof this.getTableDataUrl != "undefined") {
      let loading = this.loadingCtrl.create({
        content: 'Bitte warten...'
      });
      loading.present();
      let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(this.navParams.get('postParams'));
      this._ebsWebService.postData(this.getTableDataUrl, postPayloadObject).subscribe(res => {
        this.processData(res);
        this.setCollapsedStatus(this.tableData.body, collapsedStatus);
        this.data = res;
        this.beforeSearchData = this.data;
        this.title = res.Caption;
        loading.dismiss();
      });
    }
  }

  ionViewWillLeave() {
    this.events.unsubscribe('table:updateLayout', null);
  }

  updateLayout(newLayout) {
    console.log(this.data);
    this.layout = newLayout;
    let body = this.getTableBody(this.data);
    let header = this.getTableHeader(this.data);
    if (this.layout.groupings.length != 0) {
      body = this.groupTableBody(body, this.layout.groupings, undefined, 0, undefined);
      if (this.layout.sum.length != 0) {
        this.sumGroupings(body, this.layout.sum);
      }
    }
    if (this.layout.sort != undefined && this.layout.sort.length != 0) {
      this.sortTableBody(body, this.layout.sort, []);
    }
    this.tableData = { header: header, body: body, columnCount: this.determinColumnCount(header, body) };
  }

  saveLayout(layout) {
    if (this.saveLayoutObj == undefined) {
      return;
    }

    let postPayloadString = this._ebsWebService.buildPostPayloadObjectFromGetParameters(this.saveLayoutObj.PostParameters);
    let postPayloadObj = JSON.parse(postPayloadString);
    postPayloadObj.editValue = JSON.stringify(layout);
    postPayloadString = JSON.stringify(postPayloadObj);
    this._ebsWebService.postData(this.saveLayoutObj.ActionUrl, postPayloadString).toPromise().then(result => {
      console.log(result);
    });
  }

  openLayoutMenu(element, event) {
    let popover = this.popoverCtrl.create(TablePopoverLayout, {
      layout: this.layout,
      headerObj: element
    });
    popover.present({ ev: event });
  }

  openLayoutMenuMobile(element, event) {
    console.log(element);
    let popover = this.popoverCtrl.create(TablePopoverLayout, {
      layout: this.layout,
      headerObj: { DisplayText: '', FieldName: element.FieldName }
    });
    popover.present({ ev: event });
  }

  getCollapsedStatus(data, arr) {
    for (let i = 0; i < data.length; i++) {
      if (data[i].collapsed != undefined) {
        this.getCollapsedStatus(data[i].data, arr);
        arr.push({ name: data[i].groupingName, collapsed: data[i].collapsed });
      }
    }
  }

  setCollapsedStatus(data, arr) {
    for (let i = 0; i < data.length; i++) {
      if (data[i].collapsed != undefined) {
        this.setCollapsedStatus(data[i].data, arr);
        let found = arr.find(element => element.name == data[i].groupingName);
        if (found != undefined) {
          data[i].collapsed = found.collapsed;
        }
      }
    }
  }

  showMore(item, event) {
    if (item == undefined) {
      return;
    }
    let collapsedStatus = [];
    this.getCollapsedStatus(this.tableData.body, collapsedStatus);
    let actions = item.ListItemAction;
    let popover = this.popoverCtrl.create(TablePopoverMore, {
      ListItemAction: actions,
      navCtrl: this.navCtrl,
      collapsedStatus: collapsedStatus
    });
    popover.present({ ev: event });
  }

  addItem() {
    console.log(this.addObj);
    let navParams = {
      title: undefined,
      actionURL: this.addObj.ActionUrl,
      postParams: this.addObj.PostParameters
    };
    this._ebsComponentService.navigationController(this.addObj, navParams, this.navCtrl);
  }

  processData(data) {
    if (data.ListItemAction != undefined) {
      this.addObj = data.ListItemAction.find(element => element.ActionName == 'New');
      this.saveLayoutObj = data.ListItemAction.find(element => element.ActionName == 'SaveLayout');
    }

    if (data.Dynamic != undefined && data.Dynamic != null && data.Dynamic.TableLayout) {
      this.layout = JSON.parse(data.Dynamic.TableLayout);
    }

    let header = this.getTableHeader(data);
    let body = this.getTableBody(data);
    if (this.layout != undefined) {
      if (this.layout.groupings != undefined && this.layout.groupings.length != 0) {
        body = this.groupTableBody(body, this.layout.groupings, undefined, 0, undefined);
        if (this.layout.sum != undefined && this.layout.sum.length != 0) {
          this.sumGroupings(body, this.layout.sum);
        }
      }
      if (this.layout.sort != undefined && this.layout.sort.length != 0) {
        this.sortTableBody(body, this.layout.sort, []);
      }
    } else {
      this.layout = { groupings: [], sum: [] };
    }
    this.tableData = { header: header, body: body, columnCount: this.determinColumnCount(header, body) };

    console.log(this.tableData);
  }

  determinColumnCount(header, body) {
    if (this.addObj != undefined) {
      return header.length + 1;
    } else if (this.hasMeatballMenu(body)) {
      return header.length + 1;
    } else {
      return header.length;
    }
  }

  hasMeatballMenu(data) {
    console.log(data);
    if (data == undefined) {
      return false;
    }
    for (let i = 0; i < data.length; i++) {
      if (data[i].data != undefined) {
        return this.hasMeatballMenu(data[i].data);
      } else {
        if (data[i].ListItemAction != undefined && data[i].ListItemAction.length != 0) {
          return true;
        }
      }
    }
    return false;
  }

  sumGroupings(data, sum) {
    for (let i = 0; i < data.length; i++) {
      if (data[i].data != undefined) { // if branch element, go deeper
        this.sumGroupings(data[i].data, sum);

        if (data[i].parent != undefined) { // only add sum to parent if parent exists
          if (data[i].parent.sum == undefined) { // if parent has no sum yet
            data[i].parent.sum = [];

            for (let j = 0; j < data[i].sum.length; j++) {
              let newParentSumObj = {};
              newParentSumObj['key'] = data[i].sum[j].key;
              newParentSumObj['val'] = data[i].sum[j].val;
              newParentSumObj['label'] = data[i].sum[j].label;
              data[i].parent.sum.push(newParentSumObj);
            }

          } else { // if parent has sum add own sum
            for (let j = 0; j < data[i].sum.length; j++) { // iterate own sum
              for (let k = 0; k < data[i].parent.sum.length; k++) { // iterate parent sum
                if (data[i].sum[j].key == data[i].parent.sum[k].key) { // find matching fields to add together
                  data[i].parent.sum[k].val += data[i].sum[j].val; // add sum
                }
              }
            }
          }
        }
      } else { // if leave element, add sum to parent
        let child = data[i];
        let parent = data[i].parent;

        let newValues = child.filter(elem => sum.includes(elem.FieldName)).map(elem => {
          let newObj = {}
          newObj['key'] = elem.FieldName;
          newObj['val'] = parseFloat(elem.DisplayText) == NaN ? 0 : parseFloat(elem.DisplayText);
          newObj['label'] = elem.LabelCaption;
          return newObj;
        });


        if (parent.sum == undefined) { // create new sum object in parent
          parent.sum = [];
          for (let j = 0; j < sum.length; j++) {
            let newSumObj = {};
            newSumObj['key'] = sum[j];
            newSumObj['val'] = 0;
            parent.sum.push(newSumObj);
          }
        }

        for (let j = 0; j < newValues.length; j++) {
          for (let k = 0; k < parent.sum.length; k++) {
            if (parent.sum[k].key == newValues[j].key) {
              parent.sum[k].val += newValues[j].val;
              parent.sum[k].label = newValues[j].label;
            }
          }
        }
      }
    }
  }

  groupTableBody(data, groupings, currGroup, currDepth, parent) { // recursive magic
    if (currGroup == undefined) {
      if (groupings[0] == undefined) {
        return;
      }
      return this.groupTableBody(data, groupings, groupings[0], currDepth, undefined);
    } else {
      let processed = [];

      for (let i = 0; i < data.length; i++) {
        let row = data[i];
        for (let j = 0; j < row.length; j++) {
          let cell = row[j];
          if (cell.FieldName == currGroup) {
            let group = processed.find(element => element.groupingName == cell.DisplayText);
            if (group == undefined) {
              let arr = [];
              arr.push(row);
              let newGroup = { collapsed: true, groupingName: cell.DisplayText, data: arr, depth: currDepth, parent: parent };
              processed.push(newGroup)
              row.parent = newGroup;
            } else {
              row.parent = group;
              group.data.push(row);
            }
          }
        }
      }

      if (groupings.indexOf(currGroup) + 1 == groupings.length) {
        return processed;
      } else {
        currDepth += 1
        for (let i = 0; i < processed.length; i++) {
          processed[i].data = this.groupTableBody(processed[i].data, groupings, groupings[groupings.indexOf(currGroup) + 1], currDepth, processed[i]);
        }
        return processed;
      }
    }
  }

  sortTableBody(data, sorting, alreadySortedParents) {
    if (sorting == undefined) {
      return;
    }

    console.log(this.layout);
    if (this.layout.groupings == undefined || this.layout.groupings.length == 0) {
      console.log(this.layout);
      console.log('table is not grouped');
      sorting.forEach(sortingElement => {
        data = data.sort((e1, e2) => {
          let val1 = e1.find(prop => prop.FieldName == sortingElement.name).DisplayText;
          let val2 = e2.find(prop => prop.FieldName == sortingElement.name).DisplayText;

          val1 = this.tryParseNumber(val1);
          val1 = this.tryParseDate(val1);
          val2 = this.tryParseNumber(val2);
          val2 = this.tryParseDate(val2);

          if (val1 < val2) {
            return sortingElement.down ? -1 : 1;
          } else if (val1 > val2) {
            return sortingElement.down ? 1 : -1;
          } else {
            return 0;
          }
        });
      });
      return;
    }

    data.forEach(element => {
      if (element.data != undefined) {
        this.sortTableBody(element.data, sorting, alreadySortedParents);
      } else {
        if (!alreadySortedParents.includes(element.parent)) {
          alreadySortedParents.push(element.parent);
          sorting.forEach(sortingElement => {
            element.parent.data = element.parent.data.sort((e1, e2) => {
              let val1 = e1.find(prop => prop.FieldName == sortingElement.name).DisplayText;
              let val2 = e2.find(prop => prop.FieldName == sortingElement.name).DisplayText;

              val1 = this.tryParseNumber(val1);
              val1 = this.tryParseDate(val1);
              val2 = this.tryParseNumber(val2);
              val2 = this.tryParseDate(val2);

              if (val1 < val2) {
                return sortingElement.down ? -1 : 1;
              } else if (val1 > val2) {
                return sortingElement.down ? 1 : -1;
              } else {
                return 0;
              }
            });
          });
        }
      }
    });
  }

  tryParseNumber(val) {
    try {
      let parsed = parseFloat(val);
      if (parsed != NaN) {
        return parsed;
      }
      parsed = parseInt(val);
      return parsed == NaN ? val : parsed;
    } catch (ex) {
      return val;
    }
  }

  tryParseDate(val) {
    try {
      let parts = val.split(".");
      var parsed = new Date(
        parseInt(parts[2], 10),
        parseInt(parts[1], 10) - 1,
        parseInt(parts[0], 10));
      if (parsed.getTime() != NaN) {
        return parsed;
      } else {
        parts = val.split(":");
        if (parts.length != 2) {
          return val;
        }
        parsed = new Date(null, null, null, parts[0], parts[1]);
        return parsed.getTime() == NaN ? val : parsed;
      }
    } catch (ex) {
      return val;
    }
  }

  getTableHeader(data) {
    if (data.ListItemNavigation == undefined) {
      return [];
    }
    let header = data.ListItemNavigation[0].ListItemContent.map(element => {
      let headerObj = {
        DisplayText: element.DataType == "System.InternalLink" || element.DataType == 'System.Image' ? element.DisplayText : element.LabelCaption,
        FieldName: element.FieldName
      };
      return headerObj;
    });
    return header;
  }

  getTableBody(data) {
    let body = data.ListItemNavigation.map(element => {
      let item = element.ListItemContent;
      item.ListItemAction = element.ListItemAction;
      if (element.ListItemAction != undefined) {
      }
      return item;
    });
    return body;
  }

  //setCollapsedHeight(item) {
  //  let height = this.getCollapsibleHeight(item);
  //  document.getElementById('collapsible_' + item.groupingName).style.maxHeight = item.collapsed ? '0px' : height + 'px';
  //  if(item.parent != undefined) {
  //    setTimeout(() => {
  //      this.setCollapsedHeight(item.parent);
  //    }, 200);
  //  }
  //}

  //getCollapsibleHeight(item) {
  //  let kids = document.getElementById('collapsible_' + item.groupingName).children[0].children;
  //  let height = 0;
  //  for (let i = 0; i < kids.length; i++) {
  //    let kid = kids[i];
  //    if (kid instanceof HTMLElement) {
  //      height += kid.offsetHeight;
  //    }
  //  }
  //  return height;
  //}

  openPage(element) {
    if (this.table != null) {
      this.table.destroy();
    }
    let navParams = {
      title: element.ActionCaption,
      actionURL: element.Action,
      postParams: element.PostParameters
    };
    this._ebsComponentService.navigationController(element, navParams, this.navCtrl);
  }

  itemTapped(event, item) {
    alert("Funktion deaktiviert");
  }

  print() {
    this.printService.print('tablelist');
  }

  openAlert(action) {
    if (typeof action != "undefined") {
      let alert = this.alertCtrl.create();
      alert.setTitle(action[0].ActionGroupName);
      action.forEach(element => {
        alert.addInput({
          type: 'radio',
          label: element.DisplayName,
          value: element.ActionUrl + "?" + element.PostParameters
        });
      });
      alert.addButton('Cancel');
      alert.addButton({
        text: 'Ok',
        handler: (data: any) => {
          let urlParts = data.split("?");
          this._ebsWebService.downloadFile(urlParts[0], urlParts[1]);
        }
      });

      alert.present();
    }
  }

  onSearchInput() {
    let collapsedStatus = [];
    if (this.tableData != undefined) { // if return from view, check which row should be collapsed
      this.getCollapsedStatus(this.tableData.body, collapsedStatus);
    }

    if (this.searchword.length > 1) {
      this.showSpinner = true;

      let parsedPostPayloadObject = JSON.parse(this._ebsWebService.buildPostPayloadObjectFromGetParameters(this.data.SearchUrlPostParameters));
      parsedPostPayloadObject.searchWord = this.searchword;
      let postPayloadObject = JSON.stringify(parsedPostPayloadObject);
      this._ebsWebService.postData(this.data.SearchUrl, postPayloadObject).subscribe(res => {
        this.showSpinner = false;
        if (res.ListItemNavigation[0].ListItemContent != null && res.ListItemNavigation[0].ListItemContent.length != 0 && res.ListItemNavigation[0].ListItemContent[0].DisplayText != 'Keine Ergebnisse...') {
          this.processData(res);
          this.setCollapsedStatus(this.tableData.body, collapsedStatus);
          this.data = res;
        } else {
          let toast = this.toastCtrl.create({
            message: res.ListItemNavigation[0].ListItemContent[0].DisplayText,
            duration: 5000,
            position: 'bottom'
          });
          toast.present();
        }
      });

      setTimeout(function () {
        this.showSpinner = false;
      }, 10000)
    }
  }

  onSearchClear() {
    this.searchword = "";
    this.data = this.beforeSearchData;
  }

  openBarChart() {
    this.navCtrl.push("ChartsPage")
  }
}


// WEBPACK FOOTER //
// ./src/pages/table/table.ts